<template>
  <BaseCustomizeMetal componentCode="AI">
    <template slot="respect" slot-scope="{ text }">
      <div class="text">
        <span v-html="text.split('')[0] || ''"></span>
        <span v-html="text.split('')[1] || ''"></span>
      </div>
    </template>
  </BaseCustomizeMetal>
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAI",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 63px;
    left: 165px;
    @include betweenTableTablePro {
      top: 33px;
      left: 115px;
    }
    @include table {
      top: 19px;
      left: 90px;
    }
    @include phone {
      top: 13px;
      left: 75px;
    }
  }
  .templeName {
    height: 30px;
    width: 180px;
    .textContainer {
      width: 180px;
    }
  }
  .godName {
    width: 184px;
    height: 48px;
    .textContainer {
      width: 184px;
    }
  }
  .gift {
    width: 148px;
    height: 46px;
    .textContainer {
      width: 148px;
    }
  }
  .respect {
    margin: 6px auto;
    .text {
      position: relative;
      span {
        position: absolute;
      }
      span:nth-child(1) {
        left: -15px;
      }
      span:nth-child(2) {
        right: -3px;
      }
    }
  }
}
</style>
